// src/components/ProtectedRoute.js
import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();

  // 401 handling is owned entirely by AuthContext's own interceptor, which
  // locks the screen in place instead of navigating away - a second
  // interceptor here that redirected to /login on any 401 used to run in
  // parallel with it, yanking the user off their page (losing in-progress
  // work) the moment the JWT's fixed 15-minute expiry hit, even though
  // AuthContext's lock overlay was already handling the same 401 correctly.

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '1.2rem',
        color: '#666'
      }}>
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Admin handed this user a password they know (new account or an
  // admin-driven reset) - lock every route except the change-password form
  // until they set one only they know.
  if (user.forcePasswordChange && location.pathname !== '/profile/edit') {
    return <Navigate to="/profile/edit" replace />;
  }

  return children;
};

export default ProtectedRoute;
